import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-youkekehu",
  "use": "icon-youkekehu-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"icon-youkekehu\"><path d=\"M7.294 8.204A3.6 3.6 0 013.7 4.608a3.6 3.6 0 013.595-3.596 3.6 3.6 0 013.596 3.596 3.6 3.6 0 01-3.596 3.596zm0-6.255a2.665 2.665 0 00-2.659 2.66 2.663 2.663 0 002.66 2.658 2.663 2.663 0 002.659-2.659 2.663 2.663 0 00-2.66-2.659zm-5.372 12.51a.47.47 0 01-.469-.468c0-2.672 2.62-4.847 5.841-4.847a.47.47 0 01.469.468.47.47 0 01-.469.468c-2.701 0-4.904 1.753-4.904 3.91a.469.469 0 01-.468.469zm9.252-.375a2.473 2.473 0 010-4.943 2.473 2.473 0 012.472 2.471 2.477 2.477 0 01-2.472 2.472zm0-4.004c-.843 0-1.532.69-1.532 1.532 0 .844.69 1.532 1.532 1.532.843 0 1.532-.688 1.532-1.532 0-.843-.689-1.532-1.532-1.532zm2.375 4.379a.457.457 0 01-.332-.14l-.625-.625a.47.47 0 010-.661.474.474 0 01.664 0l.626.625a.47.47 0 01-.333.8z\" fill-rule=\"nonzero\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/youkekehu.svg
// module id = 533
// module chunks = 4